import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import flash from './modules/flash'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  loading: false
}
const actions = {
  startLoading: ({ state, commit }) => {
    commit('LOADING', true)
  },
  endLoading: ({ state, commit }) => {
    commit('LOADING', false)
  }
}

const mutations = {
  LOADING(state, payload) {
    state.loading = payload
  }
}

const getters = {
  isLoading: state => {
    return state.loading
  }
}

export default new Vuex.Store({
  modules: {
    auth,
    flash
  },
  state,
  actions,
  mutations,
  getters,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js